import { useEffect } from 'react'

import GoogleTagManager from 'integrations/googletagmanager/GoogleTagManager'

const googleTagManager = new GoogleTagManager()

export default function useGoogleTagManager() {
    useEffect(() => {
        googleTagManager.init()
    }, [])

    return googleTagManager
}
